import {
  takeLeading, call, put,
} from 'redux-saga/effects';
import { api } from '@/utils/api';
import { setAuthToken, setJWT, setRefreshToken } from '@/redux/actions/auth';
import { setCookie, deleteCookie } from '@/utils/Application/cookies';
import logger from '@/utils/logger';
import { SSO_ACCEPT_URL } from '@/config/api';
import ssoAcceptActions from './ssoAccept.actions';
import { SsoAcceptActionTypes } from './ssoAccept.types';
import { extractPath } from './ssoAccept.utils';

function* acceptSsoFlow({ payload }) {
  const jwt = payload?.jwt;

  if (!jwt || typeof jwt !== 'string') {
    yield put(ssoAcceptActions.failure('JWT não encontrado na URL'));
    return;
  }

  const request = {
    url: SSO_ACCEPT_URL,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      Accept: 'application/json',
    },
    data: new URLSearchParams({ jwt }).toString(),
    withCredentials: true,
  };

  try {
    const response = yield call(api.whmcs.post, request);
    const { data } = response.data;

    if (data.token) {
      setCookie('hg-token', data.token, false);
      localStorage.setItem('token', data.token);
      yield put(setAuthToken(data.token));
    }

    if (data.srv_token) {
      setCookie('hg-service-token', data.srv_token, false);
      yield put(setJWT(data.srv_token));
    }

    deleteCookie('hg-refresh-token');
    setCookie('hg-refresh-token', '', false, -1);
    yield put(setRefreshToken(null));

    const targetPath = extractPath(data.redirect_path || '/');
    yield put(ssoAcceptActions.success());
    window.location.replace(targetPath);
  } catch (requestError) {
    const status = requestError?.response?.status ?? 0;
    const errCode = requestError?.response?.data?.error?.code;
    const message = errCode || (status ? `HTTP ${status}` : '') || requestError?.message || 'Erro desconhecido';

    logger.error(SsoAcceptActionTypes.FAILURE, requestError, {
      status,
      reason: message,
      userRequestData: request,
    });

    yield put(ssoAcceptActions.failure(message));
  }
}

function* sagas() {
  yield takeLeading(SsoAcceptActionTypes.REQUEST, acceptSsoFlow);
}

export default sagas;
